import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionHistoryComponentData, UpdateComponentCost } from '../../../../../../app/modules/manage-components/manage-components.model';
import { ManageComponentsService } from '../../../../../../app/modules/manage-components/manage-components.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-cost-edit-popup',
  templateUrl: './cost-edit-popup.component.html',
  styleUrls: ['./cost-edit-popup.component.scss']
})
export class COstEditPopupComponent implements OnInit {
  ActionHistoryId:number;
  NewCost:number;
  constructor(public dialogRef: MatDialogRef<COstEditPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _appService: ManageComponentsService,private notification: NotificationsService,) { }
    actionHistoryComponentData:ActionHistoryComponentData[]=[];
    @ViewChild('newCostInput') newCostInput: ElementRef;
  ngOnInit(): void {
    this.ActionHistoryId = this.data.HistoryId;
    this.loadEquipmentsActionHistory();
  }
  ngAfterViewInit() {
    // Ensure the input field does not have focus initially
    this.newCostInput.nativeElement.blur();
  }
  historyLoading:boolean;

  loadEquipmentsActionHistory() {
    this.historyLoading=true;
    this._appService.GetActionHistoryComponent(this.ActionHistoryId).subscribe(
      result => {
        if(result!=null){
          this.actionHistoryComponentData= result;
          this.historyLoading=false;
        }
      },
      error => {
        console.error(error);
      },
    );
  }

  updateComponentCost= {} as UpdateComponentCost;
 
  UpdateComponentCost( point: ActionHistoryComponentData){
    if(point.NewCost !=null || point.NewCost!=undefined)

    {
      point.Cost = point.NewCost;
      this.updateComponentCost.HistoryId= this.ActionHistoryId;
      this.updateComponentCost.CompartTypeId=point.CompartTypeId;
      this.updateComponentCost.EqUnitId=point.EqUnitId;
      this.updateComponentCost.Cost= point.NewCost;
      if(point.CompartTypeId==236){
        this.updateComponentCost.TotalCost= point.NewCost;
  
      }else{
      const TotalCost=  this.actionHistoryComponentData
      .filter(x => x.EqUnitId !== point.EqUnitId) 
      .reduce((sum, item) => sum + item.Cost, 0);
        this.updateComponentCost.TotalCost= point.NewCost+ TotalCost;
      }
      this._appService.UpdateComponentCost(this.updateComponentCost).subscribe(
        result => {
          if(result!=null){
            this.notification.success("Cost Updated Successfully");
            //this.loadEquipmentsActionHistory();
          }
        },
        error => {
          console.error(error);
        },
      );
    }
   
  }

  onNoClick(): void {
    this.dialogRef.close(true);
  }

  getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
    if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
    if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
    if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 || Pos === undefined) {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
  
    }
    if (CompartTypeId == 446)
      return 'Rear'
    return Pos.toString();
  }

}
